// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"61":"9e1866fc1c41169a","927":"bd2285fbc7cb8ff9"}[chunkId] + ".js";
};